__turbopack_context__.v({
  "error": "index-module-scss-module__-nBlWq__error",
});
